import { FC } from 'react';

import EditEquityMarketSharePurchaseContractTemplateModalBody from './components/EditEquityMarketSharePurchaseContractTemplateModalBody';
import EditEquityMarketSharePurchaseContractTemplateModalFooter from './components/EditEquityMarketSharePurchaseContractTemplateModalFooter';
import EditEquityMarketSharePurchaseContractTemplateModalHeader from './components/EditEquityMarketSharePurchaseContractTemplateModalHeader';

const EditEquityMarketSharePurchaseContractTemplateModal: FC = () => (
  <>
    <EditEquityMarketSharePurchaseContractTemplateModalHeader />
    <EditEquityMarketSharePurchaseContractTemplateModalBody />
    <EditEquityMarketSharePurchaseContractTemplateModalFooter />
  </>
);

export default EditEquityMarketSharePurchaseContractTemplateModal;
